export const iconFontAwesomeEditingCube = (
	<i className="fa-solid fa-cube"></i>
);
